import * as React from 'react';
import { connect } from 'react-redux';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';

import { errorToast, IErrorMessage, ISuccessMessage, MenusAdminForm, renderToastContainer, successToast } from 'enchoice-fabric-react-lib';
import { List } from 'enchoice-fabric-react-lib';
import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { Route, Switch, withRouter } from 'react-router';
import { Dispatch } from 'redux';

import { CommandBar, IColumn, IObjectWithKey, Selection, SelectionMode } from 'office-ui-fabric-react';
import { withTranslation } from 'react-i18next';

import Api from '../../../components/Api';

import { AllMenuCommands } from '../../../utils/MenuItems.types';

import './MenuAdmin.css';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

const URL_BASE = '';

const divStyle = {
  height: 'calc(100% - 85px)',
  fallbacks: [{ height: '-moz-calc(100% - 85px)' }, { height: '-webkit-calc(100% - 85px)' }, { height: '-o-calc(100% - 85px)' }]
};

class MenuAdmin extends React.PureComponent<any, any> {
  private selection: Selection;

  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      menuId: params.menuId
    };

    this.onCancel = this.onCancel.bind(this);
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
    this.onSubmitError = this.onSubmitError.bind(this);
    this.isNull = this.isNull.bind(this);
    this.getUrl = this.getUrl.bind(this);
    this.onCustomBuildColumns = this.onCustomBuildColumns.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onNew = this.onNew.bind(this);
    this.onDelete = this.onDelete.bind(this);

    this.selection = new Selection({
      getKey: (item: IObjectWithKey, index?: number | undefined): string | number => {
        console.log('item getKey', item, index, (item as any).id);
        return item && (item as any).id ? (item as any).id : `${index}`;
      },
      onSelectionChanged: () => {
        this.onSelectionChanged(this.selection.getSelection());
      }
    });
  }

  public componentDidMount() {
    const { t } = this.props;

    const items: IBreadcrumbItem[] = [
      { text: t('menuAdmin.breadcrumb.home'), key: '/home' },
      { text: t('menuAdmin.breadcrumb.1level'), key: `/search/menu`, isCurrentItem: true }
    ];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    const { t, match } = this.props;

    const id = this.getIdArray();

    console.log('substring: ', this.props.location.pathname, match.url, this.props.location.pathname.replace(match.url, ''), id);
    return (
      <div className="ms-Grid" dir="ltr" style={{ padding: 0, height: '100%' }}>
        <div className="ms-Grid-row" style={{ height: '100%' }}>
          <div className="ms-Grid-col ms-sm2" style={{ padding: 0, height: '100%', borderRight: '1px solid #eaeaea' }}>
            <CommandBar
              items={this.getItems()}
              farItems={this.getFarItems()}
              ariaLabel={'Use left and right arrow keys to navigate between commands'}
            />
            <div style={divStyle}>
              <List
                getUrl={this.getUrl}
                handleResponse={this.handleResponse}
                onCustomBuildColumns={this.onCustomBuildColumns}
                selection={this.selection}
                selectionMode={SelectionMode.single}
                selectKeyOnInit={`${id}`}
                enableSearch={true}
                enableSort={true}
                height={'100%'}
                underlined={true}
                styles={{ root: { marginTop: '5px', height: '100%' } }}
              />
            </div>
          </div>
          <div className="ms-Grid-col ms-sm10" style={{ padding: 0 }}>
            <Switch>
              <Route
                exact={true}
                path={`${match.url}/new`}
                // tslint:disable-next-line:jsx-no-lambda
                render={props => (
                  <MenusAdminForm
                    url={URL_BASE}
                    title={t('menuAdmin.title.new')}
                    labelCmdBarBtnSave={t('menuAdmin.form.cmdBar.save')}
                    labelCmdBarBtnEdit={t('menuAdmin.form.cmdBar.edit')}
                    labelCmdBarBtnCancel={t('menuAdmin.form.cmdBar.cancel')}
                    labelFormId={t('menuAdmin.form.fields.id')}
                    labelFormName={t('menuAdmin.form.fields.name')}
                    labelFormDescription={t('menuAdmin.form.fields.description')}
                    labelFormCommand={t('menuAdmin.form.fields.command')}
                    labelFormFieldset={t('menuAdmin.form.fields.fieldset')}
                    labelToggleOn={t('menuAdmin.form.fields.toggle.on')}
                    labelToggleOff={t('menuAdmin.form.fields.toggle.off')}
                    labelFormMenuItemId={t('menuAdmin.form.fields.items.id')}
                    labelFormMenuItemName={t('menuAdmin.form.fields.items.name')}
                    labelFormMenuItemIcon={t('menuAdmin.form.fields.items.icon')}
                    commands={AllMenuCommands}
                    onCancel={this.onCancel}
                    onSubmitSuccess={this.onSubmitSuccess}
                    onSubmitError={this.onSubmitError}
                  />
                )}
              />
              <Route
                exact={true}
                path={`${match.url}/:menuId/edit`}
                // tslint:disable-next-line:jsx-no-lambda
                render={props => (
                  <div>
                    <MenusAdminForm
                      url={URL_BASE}
                      id={props.match.params.menuId}
                      title={t('menuAdmin.title.edit')}
                      labelCmdBarBtnSave={t('menuAdmin.form.cmdBar.save')}
                      labelCmdBarBtnEdit={t('menuAdmin.form.cmdBar.edit')}
                      labelCmdBarBtnCancel={t('menuAdmin.form.cmdBar.cancel')}
                      labelFormId={t('menuAdmin.form.fields.id')}
                      labelFormName={t('menuAdmin.form.fields.name')}
                      labelFormDescription={t('menuAdmin.form.fields.description')}
                      labelFormCommand={t('menuAdmin.form.fields.command')}
                      labelFormFieldset={t('menuAdmin.form.fields.fieldset')}
                      labelToggleOn={t('menuAdmin.form.fields.toggle.on')}
                      labelToggleOff={t('menuAdmin.form.fields.toggle.off')}
                      labelFormMenuItemId={t('menuAdmin.form.fields.items.id')}
                      labelFormMenuItemName={t('menuAdmin.form.fields.items.name')}
                      labelFormMenuItemIcon={t('menuAdmin.form.fields.items.icon')}
                      commands={AllMenuCommands}
                      onCancel={this.onCancel}
                      onSubmitSuccess={this.onSubmitSuccess}
                      onSubmitError={this.onSubmitError}
                    />
                  </div>
                )}
              />
            </Switch>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12" style={{ height: '1px' }}>
            {renderToastContainer()}
          </div>
        </div>
      </div>
    );
  }

  private onCustomBuildColumns(): IColumn[] {
    console.log('Set custom columns');
    return [
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 210,
        maxWidth: 350,
        isRowHeader: true,
        isResizable: false,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        data: 'string',
        isPadded: true
      }
    ];
  }

  private onSelectionChanged(selection: IObjectWithKey[]) {
    if (selection.length === 1) {
      this.props.history.push(`/search/menu/${(selection[0] as any).id}/edit`);
    } else {
      this.props.history.push(`/search/menu/`);
    }
  }

  private isNull(value: any) {
    return value == null || value === 'null' || value === undefined;
  }

  private handleResponse(items: any[]) {
    return items;
  }

  private getUrl(search: string, page: number, sortBy?: string, sortDesc?: boolean) {
    const qValue = this.isNull(search) ? '' : `&q=${search}`;
    const sortByValue = this.isNull(sortBy) ? '' : `&_sort=${sortBy}`;
    let sortDescValue = '';

    if (!this.isNull(sortDesc)) {
      sortDescValue = sortDesc ? '&_order=desc' : '&_order=asc';
    }
    const url = `${URL_BASE}/menus?_start=${page}&_limit=20${qValue}${sortByValue}${sortDescValue}`;
    console.log(url);
    return url;
  }

  private onCancel(): void {
    console.log('onCancel ...');
    this.selection.setAllSelected(false);

    this.props.history.push(`/search/menu/`);
  }

  private onSubmitSuccess(response: any): void {
    console.log('onSubmitSuccess ...', response);
    const msg: ISuccessMessage = {
      title: 'Success',
      message: 'Menu Created.'
    };
    successToast(msg);
    this.selection.setAllSelected(false);

    this.props.history.push(`/search/menu/`);
  }

  private onSubmitError(receivedError: any): void {
    const msg: IErrorMessage = {
      title: 'Error',
      message: 'Error Creating Menu.',
      error: receivedError
    };
    errorToast(msg);
  }

  private getItems = () => {
    const { t } = this.props;
    return [
      {
        key: 'newItem',
        name: t('menuAdmin.list.cmdBar.new'),
        iconProps: {
          iconName: 'Add'
        },
        onClick: this.onNew
      }
    ];
  };

  private getFarItems = () => {
    const { t } = this.props;
    return [
      {
        key: 'delete',
        name: t('menuAdmin.list.cmdBar.delete'),
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.onDelete
      }
    ];
  };

  private getIdArray(): any {
    return /\w+/.exec(this.props.location.pathname.replace(this.props.match.url, ''));
  }

  private onNew() {
    this.selection.setAllSelected(false);
    this.props.history.push(`/search/menu/new`);
  }

  private onDelete(): any {
    const menuId = this.getIdArray();
    const id = menuId ? menuId[0] : undefined;

    if (!id) {
      return;
    }

    Api.delete(`menus/${id}`)
      .then(response => {
        const msg: ISuccessMessage = {
          title: 'Success',
          message: 'Menu Deleted with success!'
        };
        successToast(msg);
      })
      .catch(error => {
        const msg: IErrorMessage = {
          title: 'Error',
          message: 'Error deleting Menu.',
          error: error
        };
        errorToast(msg);
      });
    this.selection.setAllSelected(false);
  }
}

export default withRouter(connect(
  null,
  mapDispatchToProps
)(withTranslation()(MenuAdmin)) as any);
